/** Skill product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { addRemoveEnum, DEFAULT_SCHEMA_VER, id, scopeEnum } from './_shared.js';

export const skillEvents = {
  'skill.created': {
    schema: z.object({ account_id: id, scope: scopeEnum, skill_id: id, skill_fqn: z.string().optional() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.revision_created': {
    schema: z.object({
      account_id: id,
      scope: scopeEnum,
      skill_id: id,
      revision_no: z.number().int().nonnegative(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.revision_restored': {
    schema: z.object({
      account_id: id,
      skill_id: id,
      restored_to_revision_no: z.number().int().nonnegative(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.archived': {
    schema: z.object({ account_id: id, scope: scopeEnum, skill_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.forked': {
    schema: z.object({
      account_id: id,
      source_skill_id: id,
      new_skill_id: id,
      scope_change: z.string().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.imported': {
    schema: z.object({
      account_id: id,
      import_source: z.string().min(1),
      skill_count: z.number().int().nonnegative(),
      import_id: id,
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.test_invoked': {
    schema: z.object({ account_id: id, skill_id: id, outcome: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'skill.allowlist_changed': {
    schema: z.object({
      account_id: id,
      kind: z.enum(['allow', 'deny']),
      entry: z.string().optional(),
      op: addRemoveEnum,
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
